import { superAxios } from '../../../shared/utils/axios';
import { addToast } from '../toasts/toastsActions';
import { toastTypes } from '../../../shared/components/Toast/ToastOptions';
import { actionSuccess } from '../utils';

export const FETCH_SUPER_ADMINS = 'FETCH_SUPER_ADMINS';
export const POST_SUPER_ADMIN = 'POST_SUPER_ADMIN';
export const DELETE_SUPER_ADMIN = 'DELETE_SUPER_ADMIN';
export const RESET_SUPER_ADMIN_PASSWORD = 'RESET_SUPER_ADMIN_PASSWORD';

const superAdminEndpoint = `${process.env.REACT_APP_ZEUS_API_URL}/dashboard/super/super-admin`;
const resetPasswordEndpoint = `${superAdminEndpoint}/reset-password`;
const deleteSuperAdminEndpoint = id => `${superAdminEndpoint}/${id}`;

const resetPasswordAction = () => ({
  type: RESET_SUPER_ADMIN_PASSWORD
});

export const fetchSuperAdmins = () => async dispatch => {
  try {
    const response = await superAxios.get(superAdminEndpoint);
    dispatch(actionSuccess(FETCH_SUPER_ADMINS, response?.data?.data));
    return response?.data?.data;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

export const postSuperAdmin = email => async dispatch => {
  try {
    const response = await superAxios.post(superAdminEndpoint, { email });
    dispatch(actionSuccess(POST_SUPER_ADMIN, response?.data?.data));

    dispatch(addToast(toastTypes.success));
    return response?.data?.data;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

export const deleteSuperAdmin = superAdminId => async dispatch => {
  try {
    const response = await superAxios.delete(deleteSuperAdminEndpoint(superAdminId));
    dispatch(actionSuccess(DELETE_SUPER_ADMIN, response?.data?.data));

    dispatch(addToast(toastTypes.success));
    return response;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

export const resetSuperAdminPassword = email => async dispatch => {
  try {
    await superAxios.post(resetPasswordEndpoint, {
      email
    });
    dispatch(resetPasswordAction());
    dispatch(addToast(toastTypes.success));
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};
